import React, { useState, useEffect } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { StarIcon, SearchIcon, WifiIcon } from 'lucide-react';
import { useAuth } from '../lib/AuthContext';
import { toast, ToastContainer } from 'react-toastify';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import BookSessionPage from '../pages/BookSessionPage';
import TherapistCard from '../components/TherapistCard';



const ClientFindTherapist = ({ onSubmit }) => {
  const { accessToken: token } = useAuth();
  const [therapists, setTherapists] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showBookingModal, setShowBookingModal] = useState(false);
  const [selectedTherapistId, setSelectedTherapistId] = useState(null);

  const handleOpenBookingModal = (therapistId) => {
    setSelectedTherapistId(therapistId);
    setShowBookingModal(true);
  };

  const handleCloseBookingModal = () => {
    setShowBookingModal(false);
    setSelectedTherapistId(null);
  };

  const handleBookingSubmit = (payload) => {
    // This will be handled by the onSubmit prop passed from App.jsx
    // For now, we just close the modal
    handleCloseBookingModal();
  };

  useEffect(() => {
    if (!token) return;

    const fetchTherapists = async () => {
      try {
        console.log("Fetching therapists with token:", token); // Debugging token
        const response = await fetch('https://quirkleai.com/api/therapists/', {
          headers: { Authorization: `Bearer ${token}` }
        });
        console.log("Therapists API response status:", response.status, "ok:", response.ok); // Debugging response status
        if (!response.ok) {
          const errorData = await response.json();
          console.error("Error data from API:", errorData); // Debugging error data
          throw new Error(errorData.detail || 'Failed to fetch therapists');
        }
        const data = await response.json();
        console.log("Therapists data received:", data); // Debugging received data
        setTherapists(data);
      } catch (error) {
        console.error("Error fetching therapists:", error);
        toast.error("Could not load therapists: " + error.message);
      }
    };

    fetchTherapists();
  }, [token]);

  const filteredTherapists = therapists.filter(therapist =>
    therapist.username.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (therapist.tags && therapist.tags.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  return (
    <div className="space-y-6">
      <ToastContainer position="top-right" autoClose={3000} />
      <h2 className="text-2xl font-semibold text-gray-900">Find a Therapist</h2>

      <div className="flex items-center gap-2">
        <input
          type="text"
          placeholder="Search by name, specialty or keywords"
          className="text-sm border rounded-md px-3 py-2 flex-1 focus:outline-none"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <Button variant="secondary" className="px-3 py-2">
          <SearchIcon size={16} />
        </Button>
      </div>

      {filteredTherapists.length === 0 && (
        <p className="text-sm text-gray-500">No therapists found matching your criteria.</p>
      )}

      {filteredTherapists.map((therapist) => (
        <TherapistCard key={therapist.id} therapist={therapist} onBookSession={handleOpenBookingModal} />
      ))}

      {showBookingModal && (
        <BookSessionPage
          therapistId={selectedTherapistId}
          onClose={handleCloseBookingModal}
          onSubmit={onSubmit}
        />
      )}
    </div>
  );
};

export default ClientFindTherapist;
